import Vue from 'vue';
import VueCookie from 'vue-cookie';
import apis from '../apis';

const NEW_FE_URL_BASE = (process.env.NODE_ENV !== 'production' ? '//explorer.test.com' : '//ops2.qifb888.com');

const menus = [{
    path: '',
    title: '系统管理',
    icon: 'developer_board',
    children: [{
        path: '/ops/sysconfigs/wechatMPUsers',
        title: '公众号用户',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/departments',
        title: '公司部门',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/employees',
        title: '员工账号',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/importPunchinRecords',
        title: '考勤导入',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/dicts',
        title: '字典管理',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/importElecInvoiceLogs',
        title: '电子发票',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/blacklist',
        title: '黑名单',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/coupons',
        title: '优惠券',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/ossFiles',
        title: 'OSS文件',
        perms: ['sysadmin']
    }, {
        path: '/ops/sysconfigs/datas',
        title: '数据管理',
        perms: ['sysadmin']
    }]
}, {
    path: '',
    title: '客户管理',
    icon: 'supervisor_account',
    children: [{
        path: '/ops/customers/salorDailyLogs',
        title: '通话记录',
        perms: ['customer:list', 'sysadmin']
    }, {
        path: '/ops/customers/contactFormsManage',
        title: '表单管理',
        perms: ['contactform:manage', 'sysadmin']
    }, {
        path: '/ops/customers/contactFormLogsImport',
        title: '电话导入',
        perms: ['businesscustomercontactinfo:export', 'sysadmin']
    }, {
        path: '/ops/customers/contactFormLogs',
        title: '表单记录',
        perms: ['businesscustomercontactinfo:list', 'sysadmin']
    }, {
        path: '/ops/customers/contactFormJobs',
        title: '表单任务',
        perms: ['crm:contactformjob:basic', 'sysadmin']
    }, {
        path: '/ops/customers/elecInvoiceLogs',
        title: '电子发票',
        perms: ['sysadmin']
    }, {
        path: '/ops/customers/archives',
        title: '客户档案',
        perms: ['customer:archives:manage', 'sysadmin']
    }, {
        path: '/ops/customers/contractInit',
        title: '合同生成',
        perms: ['order:add', 'sysadmin']
    }, {
        path: '/ops/customers/coupons',
        title: '优惠券',
        perms: ['customer:list', 'sysadmin']
    }, {
        path: '/ops/customers/simpleOrderSearch',
        title: '案例查询',
        perms: ['customer:list', 'sysadmin']
    }]
}, {
    path: '',
    title: '订单管理',
    icon: 'receipt',
    children: [{
        path: '/ops/orders/create',
        title: '创建订单',
        perms: ['order:add', 'sysadmin']
    }, {
        path: '/ops/orders/search',
        title: '查询订单',
        perms: ['order:list', 'order:list:department', 'order:list:self', 'sysadmin']
    }, {
        path: '/ops/orders/auditLogs',
        title: '审核订单',
        perms: ['order:doc:compile', 'order:audit', 'order:audit:department:all', 'sysadmin']
    }, {
        path: '/ops/orders/commonStatistics',
        title: '统计订单',
        perms: ['orderstatistics:list', 'orderstatistics:basecity', 'orderstatistics:all', 'sysadmin']
    }, {
        path: '/ops/orders/docModuleJobs',
        title: '技术方案任务管理',
        perms: ['doc:module:jobs:basic', 'doc:module:jobs:create', 'doc:module:jobs:assign', 'sysadmin']
    }, {
        path: '/ops/orders/orderServicePriceStatistics',
        title: '服务金额明细',
        perms: ['orderstatistics:serviceprice', 'sysadmin']
    }, {
        path: '/ops/orders/employeePerformance',
        title: '制作人员绩效统计',
        perms: ['employee:performance', 'employee:performance:basecity', 'employee:performance:department', 'employee:performance:self', 'sysadmin']
    }, {
        path: '/ops/orders/salorPerformance',
        title: '业务人员绩效统计',
        perms: ['salor:performance', 'salor:performance:department', 'order:add', 'sysadmin']
    }, {
        path: '/ops/orders/boutiqueFileAudit',
        title: '精品标书审核',
        perms: ['order:doc:compile', 'orderfile:boutique:audit', 'sysadmin']
    }, {
        path: '/ops/orders/ca',
        title: 'CA管理',
        perms: ['ca:basic', 'sysadmin']
    }]
}, {
    path: '',
    title: '制作管理',
    icon: 'description',
    children: [{
        path: '/ops/docerJobs/me',
        title: '我的任务',
        perms: ['order:doc:compile', 'sysadmin']
    }, {
        path: '/ops/docerJobs/audit',
        title: '任务审核',
        perms: ['order:doc:compile', 'order:audit', 'sysadmin']
    }, {
        path: '/ops/docerJobs/statistics',
        title: '任务统计',
        perms: ['employee', 'sysadmin']
    }, {
        path: '/ops/docerJobs/moduleDocAudit',
        title: '方案审核',
        perms: ['order:audit', 'sysadmin']
    }, {
        path: '/ops/docerJobs/materialFilesAudit',
        title: '清单审核',
        perms: ['orderfile:material:audit', 'sysadmin']
    }, {
        path: '/ops/docerJobs/configs',
        title: '参数配置',
        perms: ['order:audit', 'sysadmin']
    }, {
        path: '/ops/docerScore/configs',
        title: '评分配置',
        perms: ['sysadmin']
    }]
}, {
    path: '',
    title: '支付管理',
    icon: 'monetization_on',
    children: [{
        path: '/ops/payments/auditCreate',
        title: '新增订单支付审批',
        perms: ['orderpayment:add', 'sysadmin']
    }
    // , {
    //     path: '/ops/payments/weixin',
    //     title: '微信账户支付管理',
    //     perms: ['orderpayment:add', 'sysadmin']
    // }
    ]
}, {
    path: '',
    title: '财务管理',
    icon: 'attach_money',
    children: [{
        path: NEW_FE_URL_BASE + '/ops/finance/dailyRecords',
        target: '_blank',
        title: '台账管理',
        perms: ['finance:daily:records', 'sysadmin']
    }, {
        path: NEW_FE_URL_BASE + '/ops/finance/reimbursementLogs',
        target: '_blank',
        title: '报销申请',
        perms: ['finance:reimbursement:basic', 'sysadmin']
    }, {
        path: NEW_FE_URL_BASE + '/ops/finance/invoices',
        target: '_blank',
        title: '发票申请',
        perms: ['finance:invoice:basic', 'sysadmin']
    }, {
        path: NEW_FE_URL_BASE + '/ops/finance/adoptedPaymentLogs',
        target: '_blank',
        title: '报账认领',
        perms: ['orderpayment:add', 'sysadmin']
    }, {
        path: '/ops/finance/paymentAuditcheck',
        title: '支付审核',
        perms: ['finance:payment:check', 'finance:payment:precheck', 'finance:payment:check:partly', 'sysadmin']
    }, {
        path: '/ops/finance/orders',
        title: '订单查询',
        perms: ['finance:order:list', 'sysadmin']
    }, {
        path: '/ops/finance/receiveAccountBalances',
        title: '账户余额',
        perms: ['finance:receive_account:balance', 'sysadmin']
    }, {
        path: '/ops/finance/settlements',
        title: '结算查询',
        perms: ['finance:settlements', 'sysadmin']
    }, {
        path: '/ops/finance/punchinsCheck',
        title: '考勤统计',
        perms: ['finance:punchin:sum', 'sysadmin']
    }, {
        path: '/ops/finance/punchinVacationCheck',
        title: '请假审批',
        perms: ['finance:vacation:check', 'sysadmin']
    }, {
        path: '/ops/finance/orderMonthSum',
        title: '订单月度统计',
        perms: ['finance:order:monsum', 'sysadmin']
    }, {
        path: '/ops/finance/paymentAuditLogs',
        title: '服务变更明细',
        perms: ['finance:receive_account:logs', 'sysadmin']
    }, {
        path: '/ops/finance/receiveAccountLogs',
        title: '账户流水明细',
        perms: ['finance:receive_account:logs', 'sysadmin']
    }, {
        path: '/ops/finance/corpPayOrders',
        title: '公户订单查询',
        perms: ['finance:order:list:corppay', 'sysadmin']
    }, {
        path: '/ops/finance/corpPaymentLogs',
        title: '公户流水查询',
        perms: ['finance:order:list:corppay', 'sysadmin']
    }]
}, {
    path: '',
    title: '资料管理',
    icon: 'folder',
    children: [{
        path: '/ops/resources/techProgram',
        title: '技术方案',
        perms: ['bidresources:basic', 'sysadmin']
    }, {
        path: '/ops/resources/businessFiles',
        title: '商务资料',
        perms: ['bidresources:basic', 'sysadmin']
    }, {
        path: '/ops/resources/trainFiles',
        title: '培训资料',
        perms: ['trainresources:basic', 'sysadmin']
    }, {
        path: '/ops/resources/budgetFiles',
        title: '预算资料',
        perms: ['bidresources:basic', 'sysadmin']
    }, {
        path: '/ops/resources/budgetMaterialPrices',
        title: '预算数据',
        perms: ['order:doc:compile']
    }]
}, {
    path: '',
    title: '人事管理',
    icon: 'people',
    children: [{
        path: '/ops/hr/employees',
        title: '员工信息',
        perms: ['hr:basic', 'hr:employee:all', 'hr:employee:dep']
    },{
        path: '/ops/hr/employeeAuditLogs',
        title: '员工变更审核',
        perms: ['hr:employee:audit', 'sysadmin']
    }, {
        path: NEW_FE_URL_BASE + '/ops/hr/phones',
        target: '_blank',
        title: '公司电话',
        perms: ['hr:company:phone:edit']
    }, {
        path: NEW_FE_URL_BASE + '/ops/hr/rewardsAndPunishments',
        target: '_blank',
        title: '奖惩记录',
        perms: ['hr:rewardsandpunishiments:basic']
    }]
}, {
    path: '',
    title: '推广管理',
    icon: 'explore',
    children: [{
        path: NEW_FE_URL_BASE + '/ops/market',
        target: '_blank',
        title: '推广管理',
        perms: ['charge:account:logs:edit', 'sysadmin']
    }]
}, {
    path: '',
    title: '政采系统',
    icon: 'explore',
    children: [{
        path: NEW_FE_URL_BASE + '/_next',
        target: '_blank',
        title: '政采系统',
        perms: ['employee']
    }]
}];

/**
 * , {
    path: '',
    title: '个人中心',
    icon: 'person',
    children: [{
        path: '/ops/self/punchinRecords',
        title: '考勤管理',
        perms: ['employee']
    }]
}
 */

// initial state
const state = {
    version: '2.4',
    versionExpired: false,
    // 个人统计数据
    statistics: null,
    wechatUser: {
        avatar_url: '',
        nickname: '',
        employee_bindable: false,
        subscribe: false
    },
    employee: {
        full_name: '',
        leader: false,
        permissions: []
    },
    wechatMode: false,
    assumeEmployees: [],
    holidays: [],
    newFEURL: NEW_FE_URL_BASE,
    autoLoginCode: null
}

// getters
const getters = {
    getAuthorizedMenus(state, getters, rootState) {
        return menus.map(item => {
            const tempMenu = {};
            Object.assign(tempMenu, item);

            if (!tempMenu.children) {
                tempMenu.children = [];
            } else {
                tempMenu.children = tempMenu.children.filter(item => {
                    if (item.path.indexOf(NEW_FE_URL_BASE) === 0 &&
                        !state.autoLoginCode) {
                        return false;
                    } else {

                        item.path = item.path.split('?')[0] + '?qrcode=' + state.autoLoginCode;
                    }

                    if (!item.perms || item.perms.length === 0) {
                        return true;
                    }

                    return item.perms.filter(perm => state.employee.permissions.indexOf(perm) >= 0).length > 0;
                });
            }

            return tempMenu;
        }).filter(item => {
            if (!item.children || item.children.length === 0) {
                return false;
            }
            return true;
        });
    },
    getAuthorizedURLS(state, getters, rootState) {
        let urls = [];
        getters.getAuthorizedMenus.forEach(group => {
            urls.push(...group.children.map(item => item.path));
        });
        return urls;
    },
    // 管理员
    adminRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 业务
    salorRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:add') >= 0;
    },
    // 制作人员
    docerRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:doc:compile') >= 0;
    },
    // 审核人员
    auditorRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:audit') >= 0 ||
                state.employee.permissions.indexOf('order:audit:any') >= 0;
    },
    // 部门审核人员
    departmentAuditorRole(state, getters, rootState) {
        return state.employee.leader;
    },
    // 自审审核人员
    selftAuditorRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:audit:self') >= 0;
    },
    // 全部部门审核人员
    allDepartmentAuditorRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:audit:department:all') >= 0;
    },
    // 订单抽检人员
    orderRandomCheckRole(state) {
        return state.employee.permissions.indexOf('order:randomcheck') >= 0;
    },
    // 任务分配人员
    assignRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:assign') >= 0 ||
            state.employee.permissions.indexOf('order:assign:always') >= 0 ||
            state.employee.permissions.indexOf('order:assign:once') >= 0;
    },
    // 订单制作任务分配更多人员权限
    assignExtraDocerRole(state) {
        return state.employee.permissions.indexOf('order:docjob:assignextra') >= 0
    },
    // 订单废标责任人设置
    orderRejectedEditRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:rejected:edit') >= 0;
    },
    // 支付信息查看人员
    paymentViewRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderpayment:list') >= 0;
    },
    // 支付信息查看人员
    paymentAddRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderpayment:add') >= 0;
    },
    // 支付信息编辑人员
    paymentEditRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderpayment:edit') >= 0;
    },
    // 支付信息删除人员
    paymentDelRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderpayment:del') >= 0;
    },
    // 支付信息复核人员
    paymentManualCheckRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('sysadmin') >= 0 ||
                state.employee.permissions.indexOf('orderpayment:manualcheck') >= 0;
    },
    // 客户信息查看人员
    contactInfoViewRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderpayment:list') >= 0;
    },
    // 订单编辑人员
    orderListRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:list') >= 0 ||
                state.employee.permissions.indexOf('order:list:department') >= 0 ||
                state.employee.permissions.indexOf('order:list:self') >= 0 ||
                state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 订单编辑人员
    editorRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:edit') >= 0;
    },
    // 订单编辑人员
    orderLogViewerRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:logs:view') >= 0;
    },
    // 文件上传人员
    fileAddRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderfile:add') >= 0;
    },
    // 文件查看人员
    fileViewRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderfile:list') >= 0;
    },
    // 文件查看人员
    fileDelRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('orderfile:del') >= 0;
    },
    // 财务人员
    financeBasicRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:basic') >= 0;
    },
    // 账户余额金额不可见
    accountBalanceZeroRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:receive_account:balance:zero') >= 0;
    },
    // 支付审核-全部
    paymentAuditCheckRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:payment:check') >= 0;
    },
    // 支付审核-预审
    paymentPreAuditCheckRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:payment:precheck') >= 0;
    },
    // 支付审核-部分
    paymentAuditCheckPartlyRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:payment:check:partly') >= 0;
    },
    // 制作人员绩效设置人员
    employeePerformanceSetor(state, getters, rootState) {
        return state.employee.permissions.indexOf('employee:performance:set') >= 0 ||
                state.employee.permissions.indexOf('employee:performance:set:department') >= 0 ||
                state.employee.permissions.indexOf('employee:performance:set:basecity') >= 0;
    },
    // 表单导出数据人员
    customerContactExportRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('businesscustomercontactinfo:export') >= 0;
    },
    // 订单导出人员
    orderExportRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:export') >= 0;
    },
    // 审核记录导出人员
    orderAuditLogsExportRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('order:audit:export') >= 0;
    },
    // 订单通用统计查询人员
    orderCommonStatisticsRole(state, getters, rootState) {
        return  state.employee.permissions.indexOf('orderstatistics:list') >= 0 ||
                state.employee.permissions.indexOf('orderstatistics:basecity') >= 0 ||
                state.employee.permissions.indexOf('orderstatistics:all') >= 0 ||
                state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 订单统计全部查询人员
    orderCommonStatisticsAllRole(state, getters, rootState) {
        return  state.employee.permissions.indexOf('orderstatistics:all') >= 0 ||
                state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 页面表单查询人员
    customerFormListRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('businesscustomercontactinfo:list') >= 0 ||
                state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 公户明细导出
    corpPayExportRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:corppay:export') >= 0 ||
                state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 查看电话全部信息
    hrCompanyPhoneViewAllInfoRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('hr:company:phone:view:allinfo') >= 0;
    },
    // 查看电话资费信息
    hrCompanyPhoneViewFeeRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('hr:company:phone:view:fee') >= 0;
    },
    // 新增到账流水
    adoptedPaymentsEditRole(state, getters, rootState) {
        return state.employee.permissions.indexOf('finance:adoptedPayments:edit') >= 0;
    },
    // 精品文件审核人
    boutiqueFileAuditRole(state) {
        return state.employee.permissions.indexOf('orderfile:boutique:audit') >= 0;
    },
    // 客户售后处理人
    customerAfterSaleCaseRole(state) {
        return state.employee.permissions.indexOf('crm:aftersale:cases') >= 0;
    },
    // 客户售后处理人
    docModuleJobAssignRole(state) {
        return state.employee.permissions.indexOf('doc:module:jobs:assign') >= 0;
    },
    // 反馈审核人
    orderSignatureAuditRole(state) {
        return state.employee.permissions.indexOf('order:signature:audit') >= 0 ||
                state.employee.permissions.indexOf('sysadmin') >= 0;
    },
    // 客户全部可见人
    customerListAllRole(state) {
        return state.employee.permissions.indexOf('customer:list:all') >= 0;
    },
}

// actions
const actions = {
    getMe(context, callback) {
        let now = new Date();
        now.setHours(0, 0, 0, 0);

        let monthBegin = new Date();
        monthBegin.setHours(0, 0, 0, 0);
        monthBegin.setDate(1);

        let monthEnd = new Date();
        monthEnd.setHours(0, 0, 0, 0);
        monthEnd.setDate(1);
        monthEnd.setMonth(monthEnd.getMonth() + 1);

        let lastMonthStart = new Date();
        lastMonthStart.setHours(0, 0, 0, 0);
        lastMonthStart.setDate(1);
        lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);

        Vue.prototype.$http.get(apis.API_ME, {
            params: {
                statistic_start_ts: now.getTime(),
                statistic_mon_start_ts: monthBegin.getTime(),
                statistic_mon_end_ts: (monthEnd.getTime() - 1),
                statistic_last_mon_start_ts: lastMonthStart.getTime(),
                statistic_last_mon_end_ts: (monthBegin.getTime() - 1)
            }
        }).then(response => {
            if (response.data.success) {
                if (response.data.result.wechatUser) {
                    context.commit('setWechatUser', response.data.result.wechatUser);
                    context.commit('setWechatMode', true);

                    if (response.data.result.wechatUser.employee) {
                        context.commit('setEmployee', response.data.result.wechatUser.employee);    
                    }
                } else if (response.data.result.employee) {
                    context.commit('setEmployee', response.data.result.employee);
                    context.commit('setWechatMode', false);
                    context.dispatch('getAssumeEmployees');

                    VueCookie.set('_masontekweb_userinfo', JSON.stringify({
                        id: response.data.result.employee.id,
                        full_name: response.data.result.employee.full_name,
                        location: response.data.result.employee.location,
                        roles: response.data.result.employee.permissions
                                    .filter(v => ['employee', 'sysadmin', 'zcadmin', 'zclocationadmin', 'zcsalor', 'zcdocleader', 'zcdocer'].indexOf(v) >= 0)
                    }))

                    Vue.prototype.$http.post(apis.API_ME_UPDATE_AUTO_LOGIN_DATA).then(response => {
                        if (response.data.success) {
                            context.commit('setAutoLoginCode', response.data.result);
                        }
                    });
                }

                if (response.data.result.version !== context.state.version) {
                    context.commit('setVersionExpired', true);
                }

                context.commit('setStatistics', response.data.result.statistics);

                if (response.data.result.paymentAuditInitStateTotal) {
                    context.dispatch('notify/showMessage', {message: '有未审核的支付申请', color: 'warning', paymentAuditLinkVisible: true}, {root: true});
                }


                if (response.data.result.employeeContractToBeExpiredTotal &&
                    window.location.pathname.indexOf('/ops/hr/employees') < 0) {
                    Vue.prototype.$confirm(`有三个月内要到期的员工合同`, '提示', {
                                        confirmButtonText: '去查看',
                                        cancelButtonText: '知道了',
                                        type: 'warning'
                                      }).then(() => {
                                        window.location.href = '/ops/hr/employees'
                                      }).catch(() => {
                                               
                                      });
                }

                // 有CA权限的人员，检查即将过期的数量，进行提醒
                if (response.data.result.employee &&
                    response.data.result.employee.permissions &&
                    response.data.result.employee.permissions.filter(v => v == 'ca:basic').length) {

                        Vue.prototype.$http.get(apis.API_ORG_CA_STATISTICS).then(responseCA => {
                            if (responseCA.data.success && parseInt(responseCA.data.result.alarmCount) > 0 &&
                                window.location.pathname.indexOf('/ops/orders/ca') < 0) {
                                Vue.prototype.$confirm(`有${responseCA.data.result.alarmCount}个CA即将到期`, '提示', {
                                    confirmButtonText: '去查看',
                                    cancelButtonText: '知道了',
                                    type: 'warning'
                                  }).then(() => {
                                    window.location.href = '/ops/orders/ca'
                                  }).catch(() => {
                                           
                                  });
                            }
                        });
                }

                // 有车辆权限的人员，检查即将过期的数量，进行提醒
                if (response.data.result.employee &&
                    response.data.result.employee.permissions &&
                    response.data.result.employee.permissions.filter(v => v == 'car:basic').length) {

                        Vue.prototype.$http.get(apis.API_ORG_CAR_STATISTICS).then(responseCar => {
                            if (responseCar.data.success &&
                                window.location.pathname.indexOf('/ops/finance/car') < 0) {

                                const insuranceCount = parseInt(responseCar.data.result.insuranceCount)
                                const maintainCount = parseInt(responseCar.data.result.maintainCount)
                                const validateCount = parseInt(responseCar.data.result.validateCount)
                                const getValidateWordCount = parseInt(responseCar.data.result.getValidateWordCount)

                                if ((insuranceCount + maintainCount + validateCount + getValidateWordCount) > 0) {

                                    let typeNames = []
                                    if (insuranceCount > 0) {
                                        typeNames.push('保险')
                                    }
                                    if (maintainCount > 0) {
                                        typeNames.push('保养')
                                    }
                                    if (validateCount > 0) {
                                        typeNames.push('验车')
                                    }
                                    if (getValidateWordCount > 0) {
                                        typeNames.push('领检字')
                                    }

                                    Vue.prototype.$confirm(`有车辆需要处理${typeNames.join(',')}`, '提示', {
                                        confirmButtonText: '去查看',
                                        cancelButtonText: '知道了',
                                        type: 'warning'
                                      }).then(() => {
                                        window.location.href = '/ops/finance/car'
                                      }).catch(() => {
                                               
                                      });
                                }

                            }
                        });
                }
            } else {
                context.dispatch('notify/showMessage', {message: errorCodeUtil.parse(response.data.error.code), color: 'error'}, {root: true});
            }
            
            if (callback) {
                callback(response.data.result);
            }
        }).catch(error => {
            console.log(error)
        });
    },
    getAssumeEmployees(context) {
        Vue.prototype.$http.get(apis.API_OPS_ASSUME_EMPLOYEES).then(response => {
            if (response.data.success) {
                context.commit('setAssumeEmployees', response.data.result);
            }
        });
    },
    getHolidays(context) {
        Vue.prototype.$http.get('/api/v2/punchinHolidays', {
            params: { full_day_prefix: new Date().getFullYear(), exchange_ignore_day: false }
        }).then(response => {
            context.commit('setHolidays', response.data.map(item => item.full_day));
        });
    }
}

// mutations
const mutations = {
    setStatistics(state, payload) {
        state.statistics = payload;
    },
    setEmployee(state, payload) {
        state.employee = payload;
    },
    setWechatUser(state, payload) {
        state.wechatUser = payload;
    },
    setWechatMode(state, payload) {
        state.wechatMode = payload;
    },
    setAssumeEmployees(state, employees) {
        state.assumeEmployees = employees;
    },
    setVersionExpired(state, payload) {
        state.versionExpired = payload;
    },
    setHolidays(state, holidays) {
        state.holidays = holidays
    },
    setAutoLoginCode(state, code) {
        state.autoLoginCode = code;
    },
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js